import type {
  IEnrollmentDto,
  IEnrollmentGetAllParams,
  IEnrollmentResponse,
} from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IEnrollmentResponse>>,
  IPathBaseParam,
  IPaginationParams & IEnrollmentGetAllParams
>("enrollments");
const postApis = createPostApi<
  IApiResponse<IEnrollmentResponse>,
  IPathBaseParam,
  IEnrollmentDto
>("enrollments");
const getApis = createGetApi<
  IApiResponse<IEnrollmentResponse>,
  IPathByIdParam,
  object
>("enrollments");
const patchApis = createPatchApi<
  IApiResponse<IEnrollmentResponse>,
  IPathByIdParam,
  IEnrollmentDto
>("enrollments");

export const enrollments = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
};
